<template>
  <div>
    <v-menu offset-y v-if="(worker && isTwilioInitialized) || isShowStatus">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="m-small-btn"
          :color="color"
          v-bind="attrs"
          v-on="on"
          :class="{hidden: !twilioReady}"
        >
          {{ worker.activityName }}
        </v-btn>
      </template>
      <v-list v-if="!cantNotChangeStatus">
        <v-list-item
          v-for="(status, index) in statuses"
          :key="index"
          @click="changeStatus(status)"
        >
          <v-list-item-title class="position-relative">
            <span :class="status.color" class="main-call_status change"></span>
            <span class="pl-4">{{ status.name }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-progress-circular
      indeterminate
      color="primary"
      v-else
    ></v-progress-circular>
    <p class="fs-14 description wd-status-agent-text">{{ text }}</p>
  </div>
</template>
<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { bus } from '@/main'
import { mapGetters, mapMutations } from 'vuex'
import {
  TIME_CHECK_STATUS,
  TIME_CHECK_CALLING,
  TIME_CHECK_LOG_OFF
} from '../utils/constants'
import {
  STATUS_HOLDING,
  STATUS_ONLINE,
  STATUS_OUTGOING,
  STATUS_SPEAKING,
  STATUS_TRANSFER,
  STATUS_OFFLINE, STATUS_AFTER_CALL
} from '../constants/status'
const StatusRepository = RepositoryFactory.get('status')
const TwilioRepository = RepositoryFactory.get('twilio')

export default {
  props: {
    isTwilioInitialized: Boolean
  },
  data () {
    return {
      text: 'あなたの状態',
      twilioReady: false,
      isShowStatus: false
    }
  },
  computed: {
    ...mapGetters('status', ['statuses', 'allStatuses']),
    ...mapGetters('reservation', ['worker', 'getReservation']),
    ...mapGetters('common', ['hasCallingTabs']),
    ...mapGetters({
      userInfo: 'user/getUserInfo',
      hasModalNetworkError: 'common/getHasModalLogOff'
    }),
    color () {
      const currentStatus = this.allStatuses.find((status) => status.sid === this.worker.activitySid)
      return currentStatus.color === 'null' ? 'grey' : currentStatus.color
    },
    outgoingStatus() {
      return this.allStatuses.find(status => status.status === STATUS_OUTGOING)
    },
    speakingStatus() {
      return this.allStatuses.find(status => status.status === STATUS_SPEAKING)
    },
    offlineStatus() {
      return this.allStatuses.find(status => status.status === STATUS_OFFLINE)
    },
    holdingStatus() {
      return this.allStatuses.find(status => status.status === STATUS_HOLDING)
    },
    transferStatus() {
      return this.allStatuses.find(status => status.status === STATUS_TRANSFER)
    },
    afterCallStatus() {
      return this.allStatuses.find(status => status.status === STATUS_AFTER_CALL)
    },
    cantNotChangeStatus () {
      return this.listStatusCanNotChangeStatus.indexOf(this.worker.activityName) !== -1
    },
    listStatusCanNotChangeStatus() {
      return [
        this.outgoingStatus.name,
        this.speakingStatus.name,
        this.holdingStatus.name,
        this.transferStatus.name
      ]
    }
  },
  created () {
    this.fetchListStatus()
    bus.$on('taskRouterReady', () => {
      this.twilioReady = true
    })
    if (this.worker) {
      this.twilioReady = true
    }
  },
  mounted() {
    setTimeout(() => {
      if ((!this.worker || !this.isTwilioInitialized) && !this.hasModalNetworkError) {
        this.setHasModalNetworkError(true)
        this.isShowStatus = true
        this.$swal.fire({
          title: '',
          text: this.$t('messages.network_error'),
          icon: 'error',
          showConfirmButton: false
        })
      }
    }, TIME_CHECK_STATUS)
    setInterval(() => {
      if (!this.worker || !this.worker.activityName) return

      if (this.worker.activityName === this.offlineStatus.name && !this.hasModalNetworkError) {
        this.setHasModalNetworkError(true)
        this.$swal.fire({
          title: '',
          text: this.$t('common.error_network'),
          icon: 'error',
          confirmButtonText: this.$t('common.OK')
        }).then(() => {
          window.location.reload()
        })
      }
    }, TIME_CHECK_LOG_OFF)
    setInterval(() => {
      if (!this.worker || !this.worker.activityName) return
      if ([this.speakingStatus.name, this.holdingStatus.name].includes(this.worker.activityName) && !this.hasCallingTabs) {
        this.$root.$emit('changeStatusTaskRouter', { ...this.offlineStatus, onClick: true })
        bus.$emit('changeStatus')
        localStorage.setItem('lastStatus', this.afterCallStatus.sid)
      }
    }, TIME_CHECK_CALLING)
  },
  destroyed () {
    bus.$off('taskRouterReady')
  },
  watch: {
    'worker.activityName'(value) {
      if (value === 'ログオフ') {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    }
  },
  methods: {
    async fetchListStatus() {
      const response = await StatusRepository.getList(this.userInfo.company_id)
      if (response.success) {
        this.$store.commit('status/SET_STATUSES', response.data)
      }
    },
    async changeStatus(status) {
      if (!this.worker || this.worker.activityName === status.name) {
        return
      }

      if (this.getReservation) {
        this.$emit('rejectTask')
      }
      setTimeout(async () => {
        this.$root.$emit('changeStatusTaskRouter', { ...status, onClick: true })
        const statusUpdated = this.allStatuses.find(statusItem => statusItem.sid === status.sid)
        if (statusUpdated && statusUpdated.status === STATUS_ONLINE) {
          await TwilioRepository.updateConferenceInstruction()
        }
        bus.$emit('changeStatus')
      }, this.getReservation ? 8000 : 0)
    },
    ...mapMutations({
      setHasModalNetworkError: 'common/SET_HAS_MODAL_LOG_OFF'
    })
  }
}
</script>
<style lang="scss" scoped>
  .hidden {
    visibility: hidden;
  }
  .wd-status-agent-text {
    min-width: 117px;
  }
</style>
